module.exports = __webpack_public_path__ + "static/img/suolue.521d9e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/suolue.jpg
// module id = 9FBd
// module chunks = 1